export const INVOICE_FROM_DATE = new Date("2022-09-01")
export const IRELAND_BRANCH_ID = "d30b9a46-7986-4a7a-a4c1-5453b204180b"
export const EGS_BRANCH_ID = "b9962a49-2a40-49a3-a46a-84ace7e1febe"
export const TEESSIDE_BRANCH_ID = "019b26d8-c0e5-7d72-fc8a-dca4967d695f"
